import { createFileRoute } from "@tanstack/react-router";
import { EntityDetailPage } from "@/components/catalog/entity-pages";
import { type BookSearch, bookSearchSchema } from "@/lib/catalog";

export const Route = createFileRoute("/_app/_library/tags/$id")({
  validateSearch: bookSearchSchema,
  component: Page,
});

function Page() {
  const { id } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <EntityDetailPage
      kind="tags"
      id={id}
      search={search}
      onSearchChange={(patch: Partial<BookSearch>) =>
        void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: "q" in patch })
      }
    />
  );
}
